import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';

import { DataCardSettingsComponent } from '@module-definition/data-card/data-card-settings/data-card-settings.component';
import { CategoryGroupComponent } from '@module-definition/category-group/category-group.component';
import { ReorderRelationsComponent } from '@module-definition/reorder-relations/reorder-relations.component';

export const Ng1ModuleDefinition = angular
  .module('ng1module.module-definition', [])
  .directive(
    'appDataCardSettings',
    downgradeComponent({ component: DataCardSettingsComponent }) as angular.IDirectiveFactory,
  )
  .directive(
    'appCategoryGroup',
    downgradeComponent({ component: CategoryGroupComponent }) as angular.IDirectiveFactory,
  )
  .directive(
    'appReorderRelations',
    downgradeComponent({ component: ReorderRelationsComponent }) as angular.IDirectiveFactory,
  ).name;
